module.exports = __webpack_public_path__ + "static/img/img_7.1a34430a.jpg";